/**
 * Get the default redirect path based on user role
 * @param {Object} user - User object with role property
 * @returns {string} Default redirect path
 */
export const getDefaultRedirectPath = (user) => {
  // Handle case where user might be a string (from localStorage)
  let userObj = user;
  if (typeof user === 'string') {
    try {
      userObj = JSON.parse(user);
    } catch (e) {
      // console.error('[Redirect] Failed to parse user string:', e);
      userObj = null;
    }
  }

  if (!userObj) {
    // console.warn('[Redirect] No user object found, defaulting to My Queries');
    return '/dashboard/queries/raise';
  }

  // Get role from multiple possible fields (role, roleName, etc.)
  const roleValue = userObj.role || userObj.roleName || userObj.userRole || null;
  
  if (!roleValue) {
    // Always log this critical issue for debugging
    // console.warn('[Redirect] No role found in user object:', { 
      // user: userObj, 
      // availableKeys: Object.keys(userObj),
      // defaulting: 'My Queries' 
    // });
    return '/dashboard/queries/raise'; // Default to My Queries
  }

  const roleNormalized = (roleValue || '').toString().trim().toLowerCase();
  const roleUpper = (roleValue || '').toString().trim().toUpperCase();
  const roleOriginal = (roleValue || '').toString().trim();
  // A compact role key to handle variants like "Executive Director", "executive_director", etc.
  const roleKey = roleNormalized.replace(/[\s_-]+/g, '');
  const designationKey = (userObj.designation || '').toString().trim().toLowerCase().replace(/[\s_-]+/g, '');
  
  // Always log redirect decision for debugging (can be removed after fixing)
  // console.log('[Redirect] User redirect decision:', {
    // role: roleOriginal,
    // normalized: roleNormalized,
    // uppercase: roleUpper,
    // designation: userObj.designation,
    // hasDesignation: !!userObj.designation
  // });
  
  // Admin users go to SLA Dashboard
  if (roleNormalized === 'admin' || roleNormalized === 'superadmin' || roleUpper === 'ADMIN' || roleUpper === 'SUPERADMIN') {
    // console.log('[Redirect] Admin detected, redirecting to SLA Dashboard');
    return '/dashboard/analytics/sla';
  }

  // Chairman, MP, ED and similar roles: redirect to My Queries (no longer to PowerBI)
  // (PowerBI link removed from sidebar; post-login goes to My Queries)

  // GM users go to Assigned Queries
  if (roleNormalized === 'gm' || roleUpper === 'GM') {
    // console.log('[Redirect] GM detected - redirecting to Assigned Queries', {
      // role: roleOriginal,
      // normalized: roleNormalized,
      // uppercase: roleUpper
    // });
    return '/dashboard/queries/assigned';
  }

  // All other users go to My Queries
  // console.log('[Redirect] Default redirect to My Queries', {
    // role: roleOriginal,
    // normalized: roleNormalized,
    // uppercase: roleUpper,
    // designation: userObj.designation
  // });
  return '/dashboard/queries/raise';
};

